/* eslint-disable no-unused-vars */
/** @module Auth0LoggerBase */
/* eslint-disable import/extensions */
import Auth0UtilsBrowser from '../auth0-utils-browser.mjs';

/**
 * @abstract
 */
class Auth0LoggerBase {
  constructor(options = {}) {
    this._loggerOptions = options;
  }

  async log(msg) {
    await Promise.resolve();
  }

  async trace(msg) {
    await Promise.resolve();
  }

  async debug(msg) {
    await Promise.resolve();
  }

  async info(msg) {
    await Promise.resolve();
  }

  async warn(msg) {
    await Promise.resolve();
  }

  async error(msg) {
    await Promise.resolve();
  }

  async logMetric(metric) {
    await Promise.resolve();
  }

  async logCountMetric(metricPath, count = 1) {
    await this.logMetric({ path: metricPath, value: count });
  }

  get _anonymousUserSessionId() {
    if (!this._anonSessionId) {
      this._anonSessionId = Auth0UtilsBrowser.generateUUID();
      console.log('Auth0LoggerBase created new anon user session ID:', this._anonSessionId);
    }
    return this._anonSessionId;
  }

  _logMsgToString(error) {
    if (error === null || error === undefined) {
      return String(error);
    }

    switch (typeof error) {
      case 'string':
      case 'number':
      case 'boolean':
        return String(error);

      case 'object':
        try {
          // For objects, attempt to stringify. Handle arrays, errors, and plain objects.
          if (Array.isArray(error)) {
            return `Array: [${error.map(this._logMsgToString).join(', ')}]`;
          } if (error instanceof Error) {
            return `Error: ${error.name} - ${error.message}\nStack: ${error.stack}`;
          }
          return `Object: ${JSON.stringify(error, null, 2)}`;
        } catch (jsonError) {
          // Handle cases where JSON.stringify fails (e.g., circular references)
          return `Object: [Cannot stringify - ${jsonError.message}]`;
        }

      case 'function':
        return `Function: ${error.name || 'anonymous'}`;

      case 'symbol':
        return `Symbol: ${error.toString()}`;

      default:
        return `Unknown type: ${String(error)}`;
    }
  }
}

export default Auth0LoggerBase;
